export default __webpack_public_path__ + "static/media/cmc.e9a4f8ce.png";